import {
  GET_SELF_EVALUATION_LIST,
  GET_SELF_EVALUATION_LIST_SUCCESS,
  GET_SELF_EVALUATION_LIST_FAILURE,
  LOGIN_PROFILE_CREATED_RESET,
} from '../../modules/constants';

// Helper function to transform API response data to evaluationCards format
const transformApiResponse = (apiData) => {
  if (!apiData || !apiData.evaluations) {
    return [];
  }

  return apiData.evaluations.map(evaluation => {
    // Extract values from kpi_scores
    const attendancePercentage = evaluation.kpi_scores.attendance_hours?.details?.percentage || 0;
    const mashaerPercentage = evaluation.kpi_scores.mashaer_presence?.details?.days_present * 20 || 0;

    let taskPercentage = 0;
    let efficiencyPercentage = 0;

    // Handle different role types
    if (evaluation.kpi_scores.hasOwnProperty('completed_tasks')) {
      taskPercentage = evaluation.kpi_scores.completed_tasks?.details?.percentage || 0;
    } else if (evaluation.kpi_scores.hasOwnProperty('agm_tasks')) {
      taskPercentage = evaluation.kpi_scores.agm_tasks?.details?.percentage || 0;
    } else if (evaluation.kpi_scores.hasOwnProperty('office_tasks')) {
      taskPercentage = evaluation.kpi_scores.office_tasks?.details?.percentage || 0;
    }

    if (evaluation.kpi_scores.hasOwnProperty('individual_efficiency')) {
      efficiencyPercentage = evaluation.kpi_scores.individual_efficiency?.details?.percentage || 0;
    } else if (evaluation.kpi_scores.hasOwnProperty('office_efficiency')) {
      efficiencyPercentage = evaluation.kpi_scores.office_efficiency?.details?.percentage || 0;
    } else if (evaluation.kpi_scores.hasOwnProperty('task_diversity')) {
      efficiencyPercentage = evaluation.kpi_scores.task_diversity?.details?.percentage || 0;
    }

    const totalScore = evaluation.kpi_scores.total_score || 0;

    return {
      id: evaluation.employee_id,
      memberInfo: {
        name: evaluation.name,
        role: evaluation.role,
        // office: evaluation.region || apiData.office_name || "-",
        office: apiData.office_name || "-",
        email: evaluation.email
      },
      kpi_scores: evaluation.kpi_scores,
      statistics: [
        { attendance_pct: Math.round(attendancePercentage * 10) / 10 },
        { task_pct: Math.round(taskPercentage * 10) / 10 },
        { efficiency_pct: Math.round(efficiencyPercentage * 10) / 10 },
        { attendace_hajj_days_pct: Math.round(mashaerPercentage * 10) / 10 },
        { final_evaluation_pct: Math.round(totalScore * 10) / 10 }
      ]
    };
  });
};

// ------------------------------------
// Action handler methods
// ------------------------------------

export const handleSelfEvaluationList = (state, action) => {
  return {
    ...state,
    selfEvaluationListIsLoading: true,
  };
};

export const handleSelfEvaluationListSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    console.log('data', data);
    const payload = data.data[0];
    // Transform API response to evaluationCards format
    const evaluationCards = transformApiResponse(payload);

    return {
      ...state,
      selfEvaluationListIsLoading: false,
      officeName: payload.office_name,
      periodStart: payload.period_start,
      periodEnd: payload.period_end,
      evaluations: payload.evaluations,
      evaluationCards: evaluationCards,
    };
  }
  return {
    ...state,
    selfEvaluationListIsLoading: false,
  };
};

export const handleSelfEvaluationListFailure = (state, action) => {
  return {
    ...state,
    selfEvaluationListIsLoading: false,
    officeName: null,
    periodStart: null,
    periodEnd: null,
    evaluations: [],
    evaluationCards: [],
  };
};

export const handleLogoutRequest = (state, action) => {
  return {
    ...state,
    ...initialState,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_SELF_EVALUATION_LIST]: handleSelfEvaluationList,
  [GET_SELF_EVALUATION_LIST_SUCCESS]: handleSelfEvaluationListSuccess,
  [GET_SELF_EVALUATION_LIST_FAILURE]: handleSelfEvaluationListFailure,
  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
};

// default initial state
const initialState = {
  selfEvaluationListIsLoading: false,
  officeName: null,
  periodStart: null,
  periodEnd: null,
  evaluations: [],
  evaluationCards: [],
};

export default function selfEvaluationReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}